<div class="crm-scroll flex h-full flex-col overflow-auto bg-white text-slate-900">
  <header class="flex items-center gap-3 border-b !border-slate-200 p-4">
    <app-icon class="text-orange-600">receipt_long</app-icon>
    <h2 class="!m-0 !text-lg !font-semibold flex-1">{{ (register ? 'prro.edit_register' : 'prro.connect') | translate }}</h2>
    <app-button btnType="icon" [disabled]="busy" [ariaLabel]="'close' | translate" (onChangeClick)="requestClose()">
      <app-icon>close</app-icon>
    </app-button>
  </header>
  <div class="flex flex-1 flex-col gap-4 p-4">
    @if (register) {
      <p class="!m-0 text-sm text-slate-500">{{ 'prro.fiscal_number' | translate }}: {{ register.fiscal_number }}</p>
    }
    <app-input [(ngModel)]="name" [label]="'prro.name' | translate" [required]="true" [maxlength]="255" [disabled]="busy" />
    <app-input
      [(ngModel)]="token"
      inputType="password"
      [label]="'prro.token' | translate"
      [required]="!register"
      [maxlength]="4096"
      [disabled]="busy"
    />
    <p class="!m-0 text-sm text-slate-500">{{ 'prro.token_hint' | translate }}</p>
  </div>
  <footer class="flex items-center justify-end gap-3 border-t !border-slate-200 p-4">
    <app-button btnType="stroked" [disabled]="busy" (onChangeClick)="requestClose()">{{ 'cancel' | translate }}</app-button>
    <app-button [disabled]="busy || !name.trim() || (!register && !token.trim())" (onChangeClick)="save()">{{ 'save' | translate }}</app-button>
  </footer>
</div>
